"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _gridModule = _interopRequireDefault(require("@albelli/arc-3/lib/grid.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Grid = _ref => {
  let {
    children,
    className,
    container,
    cell,
    noSpacing,
    halfSpacing,
    column,
    columnDesktopXl,
    columnDesktop,
    columnTablet,
    columnPhone,
    offset,
    offsetDesktopXl,
    offsetDesktop,
    offsetTablet,
    offsetPhone,
    order,
    orderDesktopXl,
    orderDesktop,
    orderTablet,
    orderPhone,
    hideDesktopXl,
    hideDesktop,
    hideTablet,
    hidePhone,
    mobileOnly,
    hideSmall,
    align,
    ...props
  } = _ref;
  const classes = (0, _classnames.default)({
    [_gridModule.default["arc3-grid"]]: container,
    [_gridModule.default["arc3-cell"]]: cell,
    [_gridModule.default["arc3-grid--no-spacing"]]: noSpacing,
    [_gridModule.default["arc3-grid--half-spacing"]]: halfSpacing,
    [_gridModule.default["arc3-cell--".concat(column, "-col")]]: column,
    [_gridModule.default["arc3-cell--".concat(columnDesktopXl, "-col-desktop-xl")]]: columnDesktopXl,
    [_gridModule.default["arc3-cell--".concat(columnDesktop, "-col-desktop")]]: columnDesktop,
    [_gridModule.default["arc3-cell--".concat(columnTablet, "-col-tablet")]]: columnTablet,
    [_gridModule.default["arc3-cell--".concat(columnPhone, "-col-phone")]]: columnPhone,
    [_gridModule.default["arc3-cell--".concat(offset, "-offset")]]: offset,
    [_gridModule.default["arc3-cell--".concat(offsetDesktopXl, "-offset-desktop-xl")]]: offsetDesktopXl,
    [_gridModule.default["arc3-cell--".concat(offsetDesktop, "-offset-desktop")]]: offsetDesktop,
    [_gridModule.default["arc3-cell--".concat(offsetTablet, "-offset-tablet")]]: offsetTablet,
    [_gridModule.default["arc3-cell--".concat(offsetPhone, "-offset-phone")]]: offsetPhone,
    [_gridModule.default["arc3-cell--order-".concat(order)]]: order,
    [_gridModule.default["arc3-cell--order-".concat(orderDesktopXl, "-desktop-xl")]]: orderDesktopXl,
    [_gridModule.default["arc3-cell--order-".concat(orderDesktop, "-desktop")]]: orderDesktop,
    [_gridModule.default["arc3-cell--order-".concat(orderTablet, "-tablet")]]: orderTablet,
    [_gridModule.default["arc3-cell--order-".concat(orderPhone, "-phone")]]: orderPhone,
    [_gridModule.default["arc3-cell--hide-desktop-xl"]]: hideDesktopXl,
    [_gridModule.default["arc3-cell--hide-desktop"]]: hideDesktop,
    [_gridModule.default["arc3-cell--hide-tablet"]]: hideTablet,
    [_gridModule.default["arc3-cell--hide-phone"]]: hidePhone,
    "arc3-hide-for-medium-up": mobileOnly,
    "arc3-hide-for-small": hideSmall,
    [_gridModule.default["arc3-cell--".concat(align)]]: align
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, props), children);
};
exports.Grid = Grid;
Grid.propTypes = {
  /** Grid content */
  children: _propTypes.default.any,
  /** Custom CSS classes */
  className: _propTypes.default.string,
  /** Defines a container as an MDL grid component */
  container: _propTypes.default.any,
  /** Defines a container as an MDL cell */
  cell: _propTypes.default.any,
  /** Modifies the grid cells to have no margin between them */
  noSpacing: _propTypes.default.any,
  /** Modifies the grid cells to have half-sized margin between them */
  halfSpacing: _propTypes.default.any,
  /** Sets the column size for the cell */
  column: _propTypes.default.number,
  /** Sets the column size for the cell to N in desktop XL mode only */
  columnDesktopXl: _propTypes.default.number,
  /** Sets the column size for the cell to N in desktop mode only */
  columnDesktop: _propTypes.default.number,
  /** Sets the column size for the cell to N in tablet mode only */
  columnTablet: _propTypes.default.number,
  /** Sets the column size for the cell to N in phone mode only */
  columnPhone: _propTypes.default.number,
  /** Adds N columns of whitespace before the cell */
  offset: _propTypes.default.number,
  /** Adds N columns of whitespace before the cell in desktop XL mode */
  offsetDesktopXl: _propTypes.default.number,
  /** Adds N columns of whitespace before the cell in desktop mode */
  offsetDesktop: _propTypes.default.number,
  /** Adds N columns of whitespace before the cell in tablet mode */
  offsetTablet: _propTypes.default.number,
  /** Adds N columns of whitespace before the cell in phone mode */
  offsetPhone: _propTypes.default.number,
  /** Reorders cell to position N */
  order: _propTypes.default.number,
  /** Reorders cell to position N when in desktop XL mode */
  orderDesktopXl: _propTypes.default.number,
  /** Reorders cell to position N when in desktop mode */
  orderDesktop: _propTypes.default.number,
  /** Reorders cell to position N when in tablet mode */
  orderTablet: _propTypes.default.number,
  /** Reorders cell to position N when in phone mode */
  orderPhone: _propTypes.default.number,
  /** Hides the cell when in desktop XL mode */
  hideDesktopXl: _propTypes.default.any,
  /** Hides the cell when in desktop mode */
  hideDesktop: _propTypes.default.any,
  /** Hides the cell when in tablet mode */
  hideTablet: _propTypes.default.any,
  /** Hides the cell when in phone mode */
  hidePhone: _propTypes.default.any,
  /** Aligns the cell */
  align: _propTypes.default.oneOf(["stretch", "top", "middle", "bottom"])
};